import { XStack } from "tamagui";
import { Image } from "../../Image";
const AVATAR_SIZE = 36;
const LOGO_SIZE = 35;

// Member avatar overlapping the Granted "G" mark. Web serves the PNGs from
// next's /static; the native variant (./BillGraphicHeader.native.tsx) bundles
// the same files via Metro's require(). Keep the two in sync.
export const BillGraphicHeader = () => <XStack alignItems="center" justifyContent="center" data-sentry-element="XStack" data-sentry-component="BillGraphicHeader" data-sentry-source-file="BillGraphicHeader.tsx">
    <Image src="/static/billAvatar.png" width={AVATAR_SIZE} height={AVATAR_SIZE} borderRadius="$brFull" marginRight={-6} zIndex={2} data-sentry-element="Image" data-sentry-source-file="BillGraphicHeader.tsx" />
    <Image src="/static/newGLogo.png" width={LOGO_SIZE} height={LOGO_SIZE} objectFit="contain" data-sentry-element="Image" data-sentry-source-file="BillGraphicHeader.tsx" />
  </XStack>;